import React from 'react';
import { Container, Content, IconsSection, Subtitle, TextSection, Title } from './ListTile.styles';
import { ListTileProps } from './ListTile.types';

export const ListTile: React.FC<ListTileProps> = ({ title, subtitle, icons, ...props }) => {
  return (
    <Container data-testid="list-tile" {...props}>
      <Content>
        <TextSection>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TextSection>
        <IconsSection>{icons}</IconsSection>
      </Content>
    </Container>
  );
};
